module.exports = __webpack_public_path__ + "static/media/play_arrow.f7bcd691.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/play_arrow.svg
// module id = 49
// module chunks = 0